import { faCommentDots } from "@fortawesome/pro-regular-svg-icons";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import truncate from "lodash-es/truncate";
import React, { useState } from "react";

import { postDetailUrl } from "@/mk2/apps/forum/helpers";
import { PostEntity } from "@/mk2/apps/forum/schemas";
import { Link } from "@/mk2/components/Link";
import { Panel } from "@/mk2/components/Panel";
import { PanelHeading } from "@/mk2/components/PanelHeading";
import { TrackClick } from "@/mk2/components/TrackClick";
import {
    FORUM_SHOW_MORE_DISCUSSIONS,
    FORUM_SIMILAR_DISCUSSIONS,
} from "@/mk/autogenerated/translations/PostDetailRelatedV2.79f63acb21aa9deadfb90fcfa0ce0729";
import { upperCaseFirst } from "@/mk/bazaar/common/filters";

import styles from "./PostDetailRelatedV2.mscss";

interface PostDetailRelatedV2Props {
    posts: PostEntity[];
    initialVisible?: number;
    defaultExpanded?: boolean;
    showHeading?: boolean;
}

const PostDetailRelatedV2: React.FunctionComponent<PostDetailRelatedV2Props> = ({
    posts,
    initialVisible = 1,
    defaultExpanded = false,
    showHeading = false,
}) => {
    const [expanded, setExpanded] = useState(defaultExpanded);

    if (posts.length === 0) {
        return null;
    }

    const visiblePosts = posts.slice(0, initialVisible);
    const hiddenPosts = posts.slice(initialVisible);

    return (
        <Panel className={styles.PostDetailRelatedV2}>
            {showHeading && <PanelHeading title={FORUM_SIMILAR_DISCUSSIONS} headingLevel={2} />}
            <ul className={styles.PostDetailRelatedV2__list}>
                {visiblePosts.map((post) => (
                    <li key={post.id} className={styles.PostDetailRelatedV2__item}>
                        <TrackClick
                            name="forum_related_click"
                            props={{
                                post_id: post.id,
                                post_slug: post.slug,
                                placement: "mobile_inline",
                            }}
                        >
                            <Link to={postDetailUrl(post)}>
                                {upperCaseFirst(truncate(post.heading, { length: 80 }))}
                            </Link>
                        </TrackClick>
                        <span className={styles.PostDetailRelatedV2__comments}>
                            <FontAwesomeIcon icon={faCommentDots} /> {post.comments}
                        </span>
                    </li>
                ))}
                {expanded &&
                    hiddenPosts.map((post) => (
                        <li key={post.id} className={styles.PostDetailRelatedV2__item}>
                            <TrackClick
                                name="forum_related_click"
                                props={{
                                    post_id: post.id,
                                    post_slug: post.slug,
                                    placement: "mobile_inline",
                                }}
                            >
                                <Link to={postDetailUrl(post)}>
                                    {upperCaseFirst(truncate(post.heading, { length: 80 }))}
                                </Link>
                            </TrackClick>
                            <span className={styles.PostDetailRelatedV2__comments}>
                                <FontAwesomeIcon icon={faCommentDots} /> {post.comments}
                            </span>
                        </li>
                    ))}
            </ul>
            {hiddenPosts.length > 0 && !expanded && (
                <button
                    className={styles.PostDetailRelatedV2__expandBtn}
                    onClick={() => setExpanded(true)}
                    type="button"
                >
                    {FORUM_SHOW_MORE_DISCUSSIONS} <FontAwesomeIcon icon={faChevronDown} />
                </button>
            )}
        </Panel>
    );
};

PostDetailRelatedV2.displayName = "PostDetailRelatedV2";

export { PostDetailRelatedV2 };
